import { Button } from "@mui/material";
import { ChannelStreamConfigCaptionInput } from "../../../__generated__/globalTypes";
import { Add } from "@mui/icons-material";
import { v4 } from "uuid";
import ChannelCaption from "./ChannelCaption";
import styled from "styled-components";

export interface ChannelStreamConfigCaptionInputWithId extends ChannelStreamConfigCaptionInput {
    id: string;
}

interface Props {
    captions: ChannelStreamConfigCaptionInputWithId[];
    disabled?: boolean;
    onChangeCaptions: (tracks: ChannelStreamConfigCaptionInputWithId[]) => void;
}
const Label = styled.label`
    font-size: 13px;
    font-weight: bolder;
`;

export default function ChannelCaptions({ onChangeCaptions, disabled, captions }: Props): JSX.Element {
    return (
        <div>
            <div>
                <Label>Captions:</Label>
            </div>
            {captions.length === 0 && <div className="text-sm text-gray-400">No caption set</div>}
            {captions.map((caption, i) => (
                <ChannelCaption
                    caption={caption}
                    allChannels={captions.filter((capt) => capt.id !== caption.id).map((capt) => capt.channel)}
                    allLabels={captions
                        .filter((capt) => capt.id !== caption.id)
                        .map((capt) => capt.label)
                        .filter((label) => label !== "")}
                    key={`caption-${i}`}
                    disabled={disabled}
                    onRemove={() => onChangeCaptions(captions.filter((capt) => capt.id !== caption.id))}
                    onChangeCaption={(capt) =>
                        onChangeCaptions(
                            captions.map((c) => {
                                if (c.id === capt.id) {
                                    return capt;
                                } else {
                                    return c;
                                }
                            }),
                        )
                    }
                />
            ))}
            <div style={{ display: disabled === true ? "none" : "flex", justifyContent: "center" }}>
                <Button
                    startIcon={<Add />}
                    color="secondary"
                    size="small"
                    onClick={() =>
                        onChangeCaptions(
                            captions.concat([
                                {
                                    id: v4(),
                                    label: "",
                                    language: "",
                                    channel: 0,
                                },
                            ]),
                        )
                    }
                >
                    Add
                </Button>
            </div>
        </div>
    );
}
